<div class="footer__container">
  <div class="footer__content">
    <div class="footer__link__container">
      <a class="footer-link" [href]="'mailto:' + environment.contactEmail">{{
        'CHARGEREPAY_DRIVER.CONTACT' | translate
      }}</a>
      <a class="footer-link" target="_blank" [href]="environment.siteNoticeLink">{{
        'CHARGEREPAY_DRIVER.SITE_NOTICE' | translate
      }}</a>
      <a class="footer-link" target="_blank" [href]="environment.dataPrivacyLink">{{
        'CHARGEREPAY_DRIVER.DATA_PRIVACY' | translate
      }}</a>
    </div>

    @if (!environment.production) {
      <div>
        {{ environment.id }}
      </div>
    }
    <div>
      {{ environment.copyright }}
    </div>
  </div>
</div>
